import React, {useRef} from 'react';
import {Button, Tag, Space, message, Tooltip} from 'antd';
import {EditOutlined, DeleteOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import SearchTable from '../../components/admin/SearchTable';
import StatusTag from '../../components/admin/StatusTag';
import {useConfirmModal} from '../../components/ConfirmModal';
import ENDPOINTS from '../../constants/endpoints';
import {ROUTES, formatPath} from '../../constants/PathRoutes';
import api from '../../services/api';

export default function AdminStaffList() {
    const navigate = useNavigate();
    const tableRef = useRef();
    const {showConfirm, ConfirmModal} = useConfirmModal();

    const handleDelete = async (id) => {
        showConfirm({
            title: 'Excluir Membro',
            description: 'Tem certeza que deseja excluir este membro da equipe?',
            type: 'danger',
            confirmText: 'Excluir',
            cancelText: 'Cancelar',
            onConfirm: async () => {
                try {
                    await api.delete(formatPath(ENDPOINTS.STAFF_DETAIL, {id}));
                    message.success('Membro excluído com sucesso');
                    tableRef.current?.refetch();
                } catch (error) {
                    message.error('Erro ao excluir membro');
                }
            }
        });
    };

    const columns = [

            {
                title: 'Nome',
                key: 'name',
                render: (_, record) => `${record.first_name} ${record.last_name}`,
            },
            {
                title: 'E-mail',
                dataIndex: 'email',
                key: 'email',
            },
            {
                title: 'Tipo',
                dataIndex: 'is_admin',
                key: 'is_admin',
                width: 120,
                render: (isAdmin) => (
                    <Tag color={isAdmin ? 'gold' : 'blue'}>
                        {isAdmin ? 'Admin' : 'Colaborador'}
                    </Tag>
                ),
            },
            {
                title: 'Status',
                dataIndex: 'is_active',
                key: 'is_active',
                width: 100,
                render: (isActive) => <StatusTag isActive={isActive}/>,
            },
            {
                title: 'Permissões',
                dataIndex: 'permissions',
                key: 'permissions',
                width: 150,
                render: (permissions, record) => {
                    const amountPermissions = permissions?.length || 0;
                    return (
                        record.is_admin ? (
                            <Tag color="gold">Todas</Tag>
                        ) : (
                            <Tooltip title={<span style={{whiteSpace: 'wrap'}}>{permissions?.map((value) => (<div>{value}</div>))}</span>}>
                                <span>{amountPermissions} {amountPermissions > 1 ? 'permissões' : 'permissão'}</span>
                            </Tooltip>
                        )
                    )
                },
            }
            ,
            {
                title: 'Ações',
                key:
                    'actions',
                width:
                    150,
                render:
                    (_, record) => (
                        <Space>
                            <Button
                                type="primary"
                                icon={<EditOutlined/>}
                                size="small"
                                onClick={() => navigate(formatPath(ROUTES.ADMIN_STAFF_EDIT, {id: record.id}))}
                            />
                            <Button
                                danger
                                icon={<DeleteOutlined/>}
                                size="small"
                                onClick={() => handleDelete(record.id)}
                            />
                        </Space>
                    ),
            }
            ,
        ]
    ;

    return (
        <>
            <SearchTable
                ref={tableRef}
                url={ENDPOINTS.STAFF_LIST}
                columns={columns}
                title="Gerenciamento de Equipe"
                buttonProps={{
                    onClick: () => navigate(ROUTES.ADMIN_STAFF_CREATE),
                    label: 'Novo Membro',
                }}
            />
            <ConfirmModal/>
        </>
    );
}